module.exports = __webpack_public_path__ + "static/media/Logo.f62a3a34.svg";